import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ViewChild } from "@angular/core";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { CokyTableColumn } from 'src/app/modules/shared/imports/components/table/table.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { CommonService } from 'src/app/modules/shared/imports/services/common.service';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { toTitleCase } from "src/app/core/services/functions.service";
import { isArray, isEmpty, isNotEmpty, isNumber, isString } from "class-validator";

import { DialogAddSellerComponent } from '../dialog-add-seller/dialog-add-seller.component';
import { DialogModifySellerComponent } from '../dialog-modify-seller/dialog-modify-seller.component';
import { DialogAssingStoreComponent } from '../dialog-assing-store/dialog-assing-store.component';

import { MainService } from '../../services/main.service';




import * as _moment from 'moment';
import { Observable } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';
import { GeneralsService } from 'src/app/core/services/generals.service';
import { NotificationHelper } from 'src/app/core/services/helpers/notification.helper';
import { S } from '@angular/cdk/keycodes';
import { Console } from 'console';

const DATE_FORMAT = {
    parse: {
        dateInput: 'LL',
    },
    display: {
        dateInput: 'DD-MM-YYYY',
        monthYearLabel: 'YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'YYYY',
    },
};

@Component({
    selector: 'app-cajero-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT },
    ],
})
export class MainComponent implements OnInit, OnChanges {
    lengthReferencia: number = 0;
    stores: any
    storesFiltered: any
    title: string = "Listado"
    description: string = "Seleccione un registro para modificar"
    showFieldAudit = false;
    showFieldInactive = false;
    columns: CokyTableColumn[] = [
        { name: 'COD', title: 'CODIGO' },
        { name: 'DES', title: 'NOMBRE' },
        { name: 'USUARIO', title: 'USUARIO' },
        { name: 'C_AGE', title: 'TIENDA' },
        { name: 'EST', title: 'ESTADO' },
        { name: 'TIPO', title: 'TIPO' },
        { name: 'APL_CAJARAP', title: 'CAJA RAPIDA' },
        { name: 'TIPO_CAJERO', title: 'TIPO CAJERO' },
        { name: 'CREACION', title: 'CREACIÓN' },
        { name: 'MODIFICACION', title: 'MODIFICACIÓN' },
        { name: "ACTIONS", title: "acciones" },
    ]
    inactivos = true
    page = 1
    size = 10
    data = []

    displayedColumns: string[] = this.columns.map(value => { return value.name })

    dataSource
    selected = new Set<any>();
    ctrlTiendas = '';



    constructor(
        private mainService: MainService,
        private formBuilder: FormBuilder,
        private _notificationService: NotificationHelper,
        private helpers: HelpersService,
        private dialog: MatDialog,
        private commonService: CommonService,
        private generalService: GeneralsService) {

    }

    ngOnChanges(changes: SimpleChanges): void {

    }
    async ngOnInit(): Promise<void> {


        showSpinner()
        console.log(this.ctrlTiendas)
        this.data = (await this.mainService.findRegister(this.showFieldInactive, this.page, this.size, this.ctrlTiendas['C_AGE']))['data']
        this.stores = (await this.commonService.findAllStores())['data']
        this.storesFiltered = this.stores
        // await this.get_all_groups(!this.showFieldInactive)


        this.dataSource = new MatTableDataSource<any>(this.data);

        if (this.columns.length == 0 && this.dataSource.data.length > 0) {
            for (const key in this.data[0]) {
                console.log(Object.prototype.hasOwnProperty.call(this.data[0], key))
                if (Object.prototype.hasOwnProperty.call(this.data[0], key)) {
                    console.log(key)
                    this.columns.push({ name: key, title: toTitleCase(key) })
                }
            }
            this.columns.push({ name: "actions".toLowerCase(), title: "acciones" })
        }

        this.displayedColumns = this.columns.map(value => { return value.name })


        if (this.showFieldAudit) {
            this.displayedColumns = this.displayedColumns.filter(value => {
                console.log(value)
                return value.toUpperCase() != 'TIPO' && value.toUpperCase() != 'C_AGE' && value.toUpperCase() != 'APL_CAJARAP' && value.toUpperCase() != 'TIPO_CAJERO'
            })
        } else {
            this.displayedColumns = this.displayedColumns.filter(value => {
                return value.toUpperCase() != 'CREACION' && value.toUpperCase() != 'MODIFICACION'
            })
        }
        hideSpinner()

    }

    async get_all_groups(status: boolean) {
        showSpinner()
        try {
            // const result = await this.productsGservice.find_all_gropus(status)
            // if (result.data.statusCode == 200) {
            //   this.data = result.data.body.data
            // } else {
            //   this.helpers.notifications.errorMessage(result.data.body.message)
            // }
        } catch (error) {
            // const message = getErrorMessage(error)
            // this.helpers.notifications.errorMessage(message)
        }
        hideSpinner()
    }
    showAudit(e) {
        console.log("aqui")
        this.showFieldAudit = e
        this.ngOnInit()
    }
    showInactive(e) {
        this.ngOnInit();
    }
    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        // if (this.dataSource.paginator) {
        //   this.dataSource.paginator.firstPage();
        // }
    }
    storeFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value.toUpperCase();
        console.log(filterValue)
        if (!filterValue) {
            this.storesFiltered = this.stores
            return
        }
        this.storesFiltered = this.stores.filter(store => store.C_AGE.includes(filterValue) || store.NOM.toUpperCase().includes(filterValue))
        // 
        console.log(this.storesFiltered)
    }

    displayFn(code: any): string {
        console.log(code)
        return code ? `${code.C_AGE} - ${code.NOM}` : '';
    }
    render(item: CokyTableColumn, element: any) {
        item.name = item.name
        // console.log(item.name)
        // console.log(item, element)
        const el = {}
        for (const key in element) {
            if (Object.prototype.hasOwnProperty.call(element, key)) {
                el[key] = element[key]
            }
        }
        // if(isArray(el[item.name])){
        //   // const html=

        // }
        const result = item.render ? item.render(el[item.name], el) :
            (isString(el[item.name]) || isNumber(el[item.name]) || isEmpty(el[item.name]) || isArray(el[item.name]) ? el[item.name] : JSON.stringify(el[item.name]))
        // console.log(result, typeof (result), el)
        if (item.name == 'codigo') {
            // console.log(isNotEmpty(result) ? String(isNaN(Number(result)) ? result : String(result)) : "")
            return isNotEmpty(result) ? String(isNaN(Number(result)) ? result : String(result)) : ""
        }
        else if (item.name == 'codigo_sap') {
            if (el['correo'] == null) {
                return `<center>${el['codigo_sap']} <br> NO EMAIL <center>`
            }
            else {
                return `<center>${el['codigo_sap']} <br> ${el['correo']} <center>`

            }
        }
        else if (item.name == 'modificacion') {
            return `<center> ${el['usuario_mod']} <br> ${el['ult_fecha_mod']} <center>`
        }
        else if (item.name == 'C_AGE') {
            // console.log(item.name)
            let code = this.stores.find(store => store.C_AGE == el['C_AGE'])
            let res = `${el['C_AGE']} - ${el['NOM_AGE']}`
            // console.log(res)
            return res
        }
        else {

            // console.log(isNotEmpty(result) ? String(isNaN(Number(result)) ? result : Number(result)) : "")
            return isNotEmpty(result) ? String(isNaN(Number(result)) ? result : Number(result)) : ""
        }
    }
    dialogAdd() {
        const dialogConfig = new MatDialogConfig();
        // dialogConfig.data = data;
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        // dialogConfig.width = '500px';
        dialogConfig.height = "fit-content";
        const dialogRef = this.dialog.open(DialogAddSellerComponent, dialogConfig)
        dialogRef.afterClosed().subscribe(async (result) => {
            if (result == 'save') {
                this.ngOnInit()
            }


        });
    }
    dialogModify(element) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = element;
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        // dialogConfig.width = '500px';
        dialogConfig.height = "fit-content";
        const dialogRef = this.dialog.open(DialogModifySellerComponent, dialogConfig)
        dialogRef.afterClosed().subscribe(async (result) => {
            if (result == 'save') {
                this.ngOnInit()
            }
        });
    }
    dialogStores(element) {
        const dialogConfig = new MatDialogConfig();
        // dialogConfig.data = data;
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        // dialogConfig.width = '500px';
        dialogConfig.height = "fit-content";
        dialogConfig.data = element
        const dialogRef = this.dialog.open(DialogAssingStoreComponent, dialogConfig)
        dialogRef.afterClosed().subscribe(async (result) => {
            if (result == 'save') {
                this.ngOnInit()
            }

        });
    }
    changeStore() {
        // this.ctrlTiendas = tienda
        setTimeout(() => {
            console.log('Acción después de 100 ms');
            this.ngOnInit()
            // Coloca aquí el código que deseas ejecutar después de 100 ms
        }, 100);

    }

    //   displayFn(tienda: Item): string {
    //   return tienda ? `${ tienda.nombre } ` : '';
    // }

    changeState(item) {
        // this.data = this.data.map((x) => {
        //   console.log(x["C_VEN"], item["C_VEN"])
        //   if (x["C_VEN"] == item["C_VEN"]) {
        //     console.log(x, item)

        //     if (x["EST"] == "A") {
        //       x["EST"] = "I"

        //     }
        //     else { x["EST"] = "A" }
        //   }
        //   return x
        // })
        // console.log(this.data)
        // this.ngOnChanges()
    }
}
